import React from 'react';
import { Button } from './ui/button';
import CSS3DHero from './CSS3DHero';
import { useState, useEffect } from "react";

const ScrambleNumber = ({ value, duration = 2000 }) => {
  const [display, setDisplay] = useState(value);

  useEffect(() => {
    const intervalTime = 60;
    const totalIterations = duration / intervalTime;
    let iteration = 0;

    const interval = setInterval(() => {
      let newText = value;

      // Special handling for format like "24/7"
      if (value.includes("/")) {
        const [left, right] = value.split("/");

        const leftDigits = left.length;
        const leftMin = 0;
        const leftMax = Math.pow(10, leftDigits) - 1;

        const rightDigits = right.length;
        const rightMin = 0;
        const rightMax = Math.pow(10, rightDigits) - 1;

        const randomLeft = Math.floor(Math.random() * (leftMax - leftMin + 1)) + leftMin;
        const randomRight = Math.floor(Math.random() * (rightMax - rightMin + 1)) + rightMin;

        newText = `${randomLeft}/${randomRight}`;
      }

      // For numbers with suffix like 129+ or 72%
      else {
        const numericPart = value.replace(/\D/g, "");
        const suffix = value.replace(/[0-9]/g, "");

        const min = Math.pow(10, numericPart.length - 1);
        const max = Math.pow(10, numericPart.length) - 1;

        const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

        newText = `${randomNumber}${suffix}`;
      }

      if (iteration >= totalIterations) {
        newText = value;
        clearInterval(interval);
      }

      setDisplay(newText);
      iteration++;
    }, intervalTime);

    return () => clearInterval(interval);
  }, [value, duration]);

  return <span>{display}</span>;
};

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0B0F14] pt-20">
      {/* Grid overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(#3DF2E0 1px, transparent 1px), linear-gradient(90deg, #3DF2E0 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }} />
      </div>

      <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 gap-12 items-center relative z-10">
        {/* Left Content */}
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white font-['Qurova',sans-serif] leading-tight">
              Automate & Scale Your Business With{' '}
              <span className="text-[#3DF2E0]">AI</span>
            </h1>
            <p className="text-xl text-[#9CA3AF] font-['League_Spartan'] max-w-xl">
              At TheAikompany, we help organizations & businesses integrate artificial intelligence into their operations to automate workflows, improve efficiency, and scale faster in the AI-driven world. From AI agents and workflow automation to custom AI software, we build systems that transform how modern businesses operate.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={scrollToContact}
              className="bg-[#0B0F14] text-[#3DF2E0] border-2 border-[#3DF2E0] hover:bg-[#3DF2E0] hover:text-[#0B0F14] transition-all duration-300 rounded-md px-8 py-6 text-lg font-['Qurova']"
            >
              Book AI Consultation
            </Button>
            <Button
              onClick={scrollToContact}
              variant="outline"
              className="bg-transparent text-white border-2 border-[#1F2933] hover:border-[#3DF2E0] hover:text-[#0B0F14] transition-all duration-300 rounded-md px-8 py-6 text-lg font-['Qurova']"
            >
              Automate My Business
            </Button>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap justify-center sm:justify-between gap-6 pt-8 border-t border-[#1F2933]">

            <div className="flex flex-col items-center text-center min-w-[120px]">
              <div className="text-3xl font-bold text-[#3DF2E0] font-['JetBrains_Mono',monospace]">
                <ScrambleNumber value="129+" duration={2000} />
              </div>
              <div className="text-lg text-[#9CA3AF] font-['League_Spartan']">
                AI Systems Built
              </div>
            </div>

            <div className="flex flex-col items-center text-center min-w-[120px]">
              <div className="text-3xl font-bold text-[#3DF2E0] font-['JetBrains_Mono',monospace]">
                <ScrambleNumber value="72%" duration={2200} />
              </div>
              <div className="text-lg text-[#9CA3AF] font-['League_Spartan']">
                Cost Reduction
              </div>
            </div>

            <div className="flex flex-col items-center text-center min-w-[120px]">
              <div className="text-3xl font-bold text-[#3DF2E0] font-['JetBrains_Mono',monospace]">
                <ScrambleNumber value="24/7" duration={2400} />
              </div>
              <div className="text-lg text-[#9CA3AF] font-['League_Spartan']">
                Automation
              </div>
            </div>

          </div>
        </div>

        {/* Right 3D Visual */}
        <div className="h-[500px] lg:h-[600px] relative">
          <CSS3DHero />
        </div>
      </div>
    </section>
  );
};

export default Hero;
